import { render, staticRenderFns } from "./ComgyApiView.vue?vue&type=template&id=27b5279a&lang=pug&"
import script from "./ComgyApiView.vue?vue&type=script&lang=ts&"
export * from "./ComgyApiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports